import React, { useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  TextField,
  Button,
  Snackbar,
  Alert,
  Backdrop,
  CircularProgress,
  Typography,
  Box,
  Grid,
  Container,
  Paper,
  MenuItem
} from "@mui/material";
import { BsArrowRight } from "react-icons/bs";
import { vendorApi } from "../../api/api";
import FileUploadWithPreview from "../common/FileUploadWithPreview";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
 
/* ===== YOUTUBE EMBED HELPER ===== */
const getYoutubeEmbedUrl = (url) => {
  if (!url) return "";
  const regExp = /(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([^&?/]+)/;
  const match = url.match(regExp);
  return match ? `https://www.youtube.com/embed/${match[1]}` : "";
};
 
const AddApartment = () => {
  const navigate = useNavigate();
  const fileInputRef = useRef();
 
  /* ================= BASIC INFO ================= */
  const [apartmentName, setApartmentName] = useState("");
  const [plotName, setPlotName] = useState("");
  const [city, setCity] = useState("");
  const [address, setAddress] = useState("");
  const [landArea, setLandArea] = useState("");
  const [totalFloors, setTotalFloors] = useState("");
  const [totalUnits, setTotalUnits] = useState("");
  const [totalBlocks, setTotalBlocks] = useState("");
  const [constructionStatus, setConstructionStatus] = useState("");
  const [facing, setFacing] = useState("");
  const [priceType, setPriceType] = useState("Total"); // Total / Per SqFt
  const [totalPrice, setTotalPrice] = useState("");
 
  const [commissionType, setCommissionType] = useState("");
  const [commissionValue, setCommissionValue] = useState("");
 
 
  /* ================= AMENITIES ================= */
  const [amenities, setAmenities] = useState([
    { name: "" }
  ]);
 
 
 
  /* ================= DESCRIPTION & VIDEO ================= */
  const [description, setDescription] = useState("");
  const [youtubeLink, setYoutubeLink] = useState("");
 
  /* ================= MEDIA ================= */
  const [files, setFiles] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [displayImage, setDisplayImage] = useState(null);
  const [displayPreview, setDisplayPreview] = useState(null);
 
  /* ================= UI ================= */
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success"
  });
 
  /* ================= CONTACT DETAILS ================= */
  const [ownerName, setOwnerName] = useState("");
  const [ownerMobile, setOwnerMobile] = useState("");
  const [ownerEmail, setOwnerEmail] = useState("");
  const [ownerAddress, setOwnerAddress] = useState("");


  /* ---------------- QUILL CONFIG ---------------- */
  const quillModules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link"],
      ["clean"],
    ],
  };

  const quillFormats = [
    "header",
    "bold",
    "italic",
    "underline",
    "list",
    "bullet",
    "link",
  ];


  /* ================= VALIDATION ================= */
  const validate = () => {
    const e = {};
    if (!apartmentName) e.apartmentName = "Apartment name required";
    if (!city) e.city = "City required";
    if (!address) e.address = "Address required";
    if (!landArea) e.landArea = "Land area required";
    if (!totalFloors) e.totalFloors = "Total floors required";
    if (!totalUnits) e.totalUnits = "Total units required";
    if (!constructionStatus) e.constructionStatus = "Select construction status";
    if (!displayImage) e.displayImage = "Display image required";
    if (files.length === 0) e.files = "Gallery images required";
 
    setErrors(e);
    return Object.keys(e).length === 0;
  };
 
  /* ================= HANDLERS ================= */
  const handleGalleryChange = (e) => {
    const selected = Array.from(e.target.files);
    setFiles(prev => [...prev, ...selected]);
    setPreviews(prev => [...prev, ...selected.map(f => URL.createObjectURL(f))]);
    e.target.value = null;
  };
 
  /* -------- Amenities -------- */
  const handleAmenityChange = (index, value) => {
    const updated = [...amenities];
    updated[index].name = value;
    setAmenities(updated);
  };
 
  const addAmenity = () =>
    setAmenities([...amenities, { name: "" }]);
 
  const removeAmenity = (index) => {
    const updated = amenities.filter((_, i) => i !== index);
    setAmenities(updated.length ? updated : [{ name: "" }]);
  };
 
 
 
  /* ================= SAVE ================= */
  const saveApartment = async (e) => {
    e.preventDefault();
    if (!validate()) return;
 
    setLoading(true);
    const fd = new FormData();
 
    fd.append("ApartmentName", apartmentName);
    fd.append("PlotName", plotName);
    fd.append("City", city);
    fd.append("Address", address);
    fd.append("Facing", facing);
    fd.append("LandArea", landArea);
    fd.append("TotalFloors", totalFloors);
    fd.append("TotalUnits", totalUnits);
    fd.append("TotalBlocks", totalBlocks);
    fd.append("ConstructionStatus", constructionStatus);
    fd.append("PriceType", priceType);
   fd.append("commissionType", commissionType);
fd.append("commissionValue", commissionValue);
 
    fd.append("OwnerName", ownerName);
    fd.append("OwnerMobile", ownerMobile);
    fd.append("OwnerEmail", ownerEmail);
    fd.append("OwnerAddress", ownerAddress);
 
    fd.append(
      "Amenities",
      JSON.stringify(
        amenities
          .filter(a => a.name && a.name.trim() !== "")
          .map(a => ({
            name: a.name.trim()
          }))
      )
    );
 
 
 
    fd.append("Description", description);
    fd.append("YoutubeVideo", youtubeLink);
 
    files.forEach(img => fd.append("images[]", img));
    fd.append("IconURL", displayImage);
 
    try {
      for (let [key, value] of fd.entries()) {
        console.log(key, value);
      }
      debugger
      await vendorApi.addApartment(fd);
      setSnackbar({ open: true, message: "Apartment added successfully", severity: "success" });
      setTimeout(() => navigate("/apartment"), 1500);
    } catch (err) {
      setSnackbar({ open: true, message: "Failed to save apartment", severity: "error" });
    } finally {
      setLoading(false);
    }
  };
 
  /* ================= UI ================= */
  return (
    <Container sx={{ py: 5 }}>
      <Backdrop open={loading}><CircularProgress /></Backdrop>
 
      <Snackbar open={snackbar.open} autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}>
        <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
      </Snackbar>
 
      <Box mb={3} display="flex" justifyContent="space-between">
        <Typography variant="h5">Add Apartment</Typography>
        <Box>
          <Link to="/home">Home</Link> <BsArrowRight /> <Link to="/apartment">Apartment</Link>
        </Box>
      </Box>
 
      <Paper sx={{ p: 4 }}>
        <form onSubmit={saveApartment}>
          <Grid container spacing={3}>
 
            {/* BASIC INFO */}
            <Grid item xs={12}><TextField label="Apartment Name" fullWidth value={apartmentName} onChange={e => setApartmentName(e.target.value)} /></Grid>
            <Grid item xs={12}><TextField label="City" fullWidth value={city} onChange={e => setCity(e.target.value)} /></Grid>
            <Grid item xs={12}><TextField label="Address" fullWidth value={address} onChange={e => setAddress(e.target.value)} /></Grid>
            <Grid item xs={6}><TextField label="Land Area (SqFt)" fullWidth value={landArea} onChange={e => setLandArea(e.target.value)} /></Grid>
            <Grid item xs={6}><TextField label="Total Floors" type="number" fullWidth value={totalFloors} onChange={e => setTotalFloors(e.target.value)} /></Grid>
            <Grid item xs={6}><TextField label="Total Units" type="number" fullWidth value={totalUnits} onChange={e => setTotalUnits(e.target.value)} /></Grid>
            <Grid item xs={6}><TextField label="Total Blocks" type="number" fullWidth value={totalBlocks} onChange={e => setTotalBlocks(e.target.value)} /></Grid>
            {/* PROPERTY COMMISSION TYPE */}
            <Grid item xs={12} md={6}>
              <TextField
                select
                fullWidth
                label="Property Commission Type"
                value={commissionType}
                onChange={(e) => {
                  setCommissionType(e.target.value);
                  setCommissionValue(""); // reset value when type changes
                }}
              >
                <MenuItem value="percentage">Percentage (%)</MenuItem>
                <MenuItem value="sqft">Amount per Sqft</MenuItem>
              </TextField>
            </Grid>
 
            {/* COMMISSION VALUE (CONDITIONAL) */}
            <Grid item xs={12} md={6}>
              {commissionType === "percentage" && (
                <TextField
                  fullWidth
                  type="number"
                  label="Commission Percentage (%)"
                  value={commissionValue}
                  onChange={(e) => setCommissionValue(e.target.value)}
                  InputProps={{
                    endAdornment: <Typography sx={{ ml: 1 }}>%</Typography>
                  }}
                />
              )}
 
              {commissionType === "sqft" && (
                <TextField
                  fullWidth
                  type="number"
                  label="Commission Amount per Sqft"
                  value={commissionValue}
                  onChange={(e) => setCommissionValue(e.target.value)}
                  InputProps={{
                    startAdornment: <Typography sx={{ mr: 1 }}>₹</Typography>
                  }}
                />
              )}
            </Grid>
 
            {/* Construction Status */}
            <Grid item xs={12}>
              <TextField select label="Construction Status" fullWidth value={constructionStatus} onChange={e => setConstructionStatus(e.target.value)}>
                <MenuItem value="Planning">Planning</MenuItem>
                <MenuItem value="Under Construction">Under Construction</MenuItem>
                <MenuItem value="Ready to Move">Ready to Move</MenuItem>
              </TextField>
            </Grid>
 
 
 
            {/* AMENITIES */}
            <Grid item xs={12}>
              <Typography variant="h6">Amenities</Typography>
            </Grid>
 
            {amenities.map((a, i) => (
              <Grid item xs={12} key={i}>
                <Box display="flex" gap={2}>
                  <TextField
                    label={`Amenity ${i + 1}`}
                    fullWidth
                    value={a.name}
                    onChange={(e) => handleAmenityChange(i, e.target.value)}
                  />
                  {amenities.length > 1 && (
                    <Button color="error" onClick={() => removeAmenity(i)}>
                      Remove
                    </Button>
                  )}
                </Box>
              </Grid>
            ))}
 
 
            <Grid item xs={12}>
              <Button variant="outlined" onClick={addAmenity}>
                + Add Amenity
              </Button>
            </Grid>
 
 
            {/* DESCRIPTION */}
             <Grid item xs={12}>
                          <Typography fontWeight={600}>Property Description</Typography>
                          <ReactQuill
                            value={description}
                            onChange={setDescription}
                            modules={quillModules}
                            formats={quillFormats}
                            style={{ height: 200, marginBottom: 40 }}
                          />
                        </Grid>
 
            {/* YOUTUBE LINK */}
            <Grid item xs={12}>
              <TextField
                label="YouTube Video Link"
                fullWidth
                placeholder="https://www.youtube.com/watch?v=xxxx"
                value={youtubeLink}
                onChange={e => setYoutubeLink(e.target.value)}
              />
            </Grid>
 
            {/* YOUTUBE PREVIEW */}
            {getYoutubeEmbedUrl(youtubeLink) && (
              <Grid item xs={12}>
                <Box sx={{ mt: 2, position: 'relative', paddingTop: '56.25%', borderRadius: 2, overflow: 'hidden' }}>
                  <iframe
                    src={getYoutubeEmbedUrl(youtubeLink)}
                    title="YouTube Preview"
                    allowFullScreen
                    style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
                  />
                </Box>
              </Grid>
            )}
 
            {/* ================= OWNER DETAILS ================= */}
            <Grid item xs={12}>
              <Typography variant="h6">Owner Details</Typography>
            </Grid>
 
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Owner Name"
                value={ownerName}
                onChange={(e) => setOwnerName(e.target.value)}
              />
            </Grid>
 
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Owner Mobile"
                value={ownerMobile}
                onChange={(e) => setOwnerMobile(e.target.value)}
              />
            </Grid>
 
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Owner Email"
                value={ownerEmail}
                onChange={(e) => setOwnerEmail(e.target.value)}
              />
            </Grid>
 
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Owner Address"
                multiline
                rows={2}
                value={ownerAddress}
                onChange={(e) => setOwnerAddress(e.target.value)}
              />
            </Grid>
 
 
            {/* DISPLAY IMAGE */}
            <Grid item xs={12}>
              <Button component="label" variant="outlined">
                Select Display Image
                <input hidden type="file" onChange={e => {
                  setDisplayImage(e.target.files[0]);
                  setDisplayPreview(URL.createObjectURL(e.target.files[0]));
                }} />
              </Button>
              {displayPreview && <Box mt={1}><img src={displayPreview} alt="" width={200} /></Box>}
            </Grid>
 
            {/* GALLERY IMAGES */}
            <Grid item xs={12}>
              <FileUploadWithPreview
                handleFileChange={handleGalleryChange}
                previews={previews}
                files={files}
                fileInputRef={fileInputRef}
              />
            </Grid>
          </Grid>
 
          <Box mt={4} textAlign="right">
            <Button type="submit" variant="contained">Save Apartment</Button>
          </Box>
        </form>
      </Paper>
    </Container>
  );
};
 
export default AddApartment;